export const personFields = [
  'person',
  'firstName',
  'lastName',
  'gender',
  'title',
  'address.',
  'invoiceAddress.',
  'contactProperties.',
];
